function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "225",
  height: "160",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1_9312)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1 0v156.791a2.93 2.93 0 002.931 2.931H222.07a2.93 2.93 0 002.931-2.931V0H1z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  x: "47",
  y: "27",
  width: "132",
  height: "67.714",
  rx: "3.185",
  fill: "#6310E5"
}), /*#__PURE__*/React.createElement("rect", {
  x: "63",
  y: "61",
  width: "100",
  height: "18",
  rx: "4",
  fill: "#9758F9"
}), /*#__PURE__*/React.createElement("rect", {
  width: "63",
  height: "24",
  rx: "3",
  transform: "matrix(1 0 0 -1 82 138)",
  fill: "#DDE0E4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M113.338 107.271a1.592 1.592 0 01-2.758 0L102.918 94H121l-7.662 13.271z",
  fill: "#6310E5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M63.624 41.056l3.728-1.648V50h-1.968v-7.888l-1.76.704v-1.76zm10.997-2.08h1.712L70.989 50h-1.712l5.344-11.024zm6.32 6.368h-1.12V43.6h1.12c.992.016 1.183-.88 1.183-1.152 0-.384-.175-1.04-.927-1.184-.609-.08-1.2.112-1.617.64l-1.535-1.008c.591-.992 1.808-1.632 3.168-1.552 1.791.096 3.024 1.376 3.024 2.928 0 .864-.544 1.616-1.296 2.048 1.103.416 1.855 1.728 1.743 2.848-.191 1.904-2 3.12-4.031 2.976-1.44-.096-2.689-.992-3.249-2.208.145-.08 1.569-.784 1.713-.864.303.624.975 1.168 1.695 1.168.993 0 1.76-.64 1.76-1.552 0-.272-.207-1.392-1.632-1.344z",
  fill: "#BFA6F4"
})), /*#__PURE__*/React.createElement("rect", {
  x: "1.5",
  y: "1",
  width: "222",
  height: "157.722",
  rx: "3",
  stroke: "#DDE0E4",
  strokeWidth: "2"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1_9312"
}, /*#__PURE__*/React.createElement("rect", {
  x: ".5",
  width: "224",
  height: "159.722",
  rx: "4",
  fill: "#fff"
})))));